import { Injectable } from '@angular/core';
import { ChildRecipeEntity, LocationsEntity } from '@core/redux/stores';
import { ConfirmModalService } from './confirm-modal.service';
import { Router } from '@angular/router';
import { Offer } from '@app/features/account/models/offer.model';
import { CheckTimeUtility } from '@app/features/ordering/utilties/check-time-utility';
import { OfferDiscountType, OfferPriceOverrideFilter } from '@features/account/models/offer.model';

@Injectable()
export class OfferService {
  private offerList: Offer[];
  public offerMenuIds: any;
  public offerCategoryIds: any;
  public offerSelectedData: any;
  public isBuyOneGetOne: boolean | false;
  public buy1Get1ChildReceipeId: number;
  public isOfferInCart: boolean | false;
  public offerReceipeId: any;
  public nonBOGOAddedItemRecipeId?: number;

  constructor(private confirmModalService: ConfirmModalService) {
  }
  setOfferList(offerList) {
    this.offerList = offerList;
  }
  getOfferList() {
    return this.offerList;
  }

  setOfferMenuIds(mids) {
    this.offerMenuIds = mids;
  }

  getOfferMenuIds() {
    return this.offerMenuIds;
  }

  setSelectedOffer(data : Offer) {
    const offerSelectedData = JSON.stringify(data);
    localStorage.setItem('offerSelectedData', offerSelectedData);
    this.offerSelectedData = data;
  }

  getSelectedOffer(set): Offer {
    if ((!this.offerSelectedData && !this.isOfferInCart) || set === true) {
      const offerSelectedData = localStorage.getItem('offerSelectedData');
      if (offerSelectedData) {
        this.setSelectedOffer(JSON.parse(offerSelectedData));
      }
    }
    return this.offerSelectedData;
  }
  filterOfferListByLocation(location: LocationsEntity, offerList: Offer[]): Offer[] {   

    const filteredOfferList: Offer[] = [];
    offerList.forEach(offer => {
      const offerContent = offer.overrideContent?.find(c => c.regions.find(r => r == location.unit || r == location.area || r == location.zone || r == location.region)
      &&     
      CheckTimeUtility.isCurrentTimeInBetweenRange(c?.effectiveDateTimeLocal, c?.expiryDateTimeLocal, location.timeZone)
      );
      if (offerContent)
      {
        offer.name = offerContent?.name;
        offer.description = offerContent?.description;
        offer.bannerImageUrl = offerContent?.bannerImageUrl;
        filteredOfferList.push(offer);
      } else if (offer.allowDefaultContent) {
        filteredOfferList.push(offer);
      }      
    });
    return filteredOfferList;
  }
  isBuyOneGetOneFree(offerSelectedData: any, childRecipeId: Number, recipeId: Number) {
    if (!this.offerSelectedData) {
      this.getSelectedOffer(true);
    }
    if (this.offerSelectedData.rules.addItemsAfterValidation) {

      const validationAttachToOffer = offerSelectedData.rules.addItemsAfterValidation.filter((off) => {
        return off.childRecipes.find((ch) => {
          return ch.attachToOffer === true;
          });
      });
      const buy1Get1ChildReceipeId = offerSelectedData.rules.addItemsAfterValidation.find((off) => {
              return off.childRecipes;
            }).childRecipes.find((aa) => {
              return aa.attachToOffer === true;
            });
      this.buy1Get1ChildReceipeId = buy1Get1ChildReceipeId?.childRecipeId;
      this.nonBOGOAddedItemRecipeId = offerSelectedData?.rules?.addItemsAfterValidation?.find(a => a?.childRecipes)?.childRecipes?.find(a => a?.childRecipeId)?.childRecipeId;
      this.isBuyOneGetOne = validationAttachToOffer.length !== 0 ? true : false;
    } else {
      this.isBuyOneGetOne = false;
    }
  }

  clearOffers(all) {
    if (all) {
      localStorage.removeItem('offerSelectedData');
    }
    this.offerList = null;
    this.offerMenuIds = null;
    this.offerCategoryIds = null;
    this.offerSelectedData = null;
    this.isBuyOneGetOne = false;
    this.buy1Get1ChildReceipeId = null;
    this.nonBOGOAddedItemRecipeId = null;
  }
    calculateOfferPriceForRecipe(offer: Offer, recipe: ChildRecipeEntity) {
      if(!offer) return 0;
      const basePrice = recipe?.recipeBasicInfo?.price ?? recipe.totalPrice ?? 0;
      const pOverrideFilter = this.getMatchingPriceFilterForRecipe(offer, recipe);
      if (pOverrideFilter) {
        switch (pOverrideFilter?.discountType) {
          case OfferDiscountType.Amount:
            return Math.max(basePrice - pOverrideFilter.discount, 0);
          case OfferDiscountType.Override:
            return pOverrideFilter.discount;
          case OfferDiscountType.Percent:
            return Math.max(basePrice - (basePrice * (pOverrideFilter.discount / 100)), 0);
          default:
            return basePrice;
        }
      } else {
        return basePrice;
      }
    }
  
  private getMatchingPriceFilterForRecipe(
    offerSelected: Offer,
    recipe: ChildRecipeEntity): OfferPriceOverrideFilter | null {
    const discountPrice = offerSelected?.rules?.priceOverride?.find((price) =>
      price.discount &&
      price.recipes?.some((r) =>
        r.recipeId === recipe.parentRecipeId &&
        r.childRecipes?.some(
          (c) =>
            c.childRecipeId === recipe.id ||
            c.childRecipeId === recipe.recipeId
        )
      )
    );

    return discountPrice ?? null;
  }


  verifyOfferEligibleForTheChildRecipe(recipe: ChildRecipeEntity): any {
    let filtermenu = false;
    if (this.offerSelectedData && this.offerSelectedData.rules  &&
      this.offerSelectedData.rules.filterMenu   && this.offerSelectedData.rules.filterMenu.length !== 0) {
      const filteredCategory = this.offerSelectedData.rules.filterMenu.find(el => {
        return recipe.categoryId === el.categoryId;
      });
      if (filteredCategory && filteredCategory.recipes) {
        const filteredRecipes = filteredCategory.recipes.find(rec => {
          return recipe.parentRecipeId === rec.recipeId;
        });
        if (filteredRecipes && filteredRecipes.childRecipes) {
          const filteredChildRecipe = filteredRecipes.childRecipes.find(rec => {
            return recipe.id === rec.childRecipeId;
          });
          if (filteredChildRecipe) {
            this.offerReceipeId = filteredChildRecipe.childRecipeId;
            filtermenu = true;
          }
        }
      }
    }
    return filtermenu;
  }

  verifyOfferEligibleForTheRecipe(recipe: ChildRecipeEntity): any {
    let message: any;
    if (this.offerSelectedData && this.offerSelectedData.rules && this.offerSelectedData.rules.validation) {
      this.offerSelectedData.rules.validation.forEach(validation => {
        if (validation.alert) {
          if (!this.validateOffer(validation , recipe)) {
            message = message ? message : validation.alert;
          }
          if (this.offerSelectedData.rules.validation.length === this.offerSelectedData.rules.validation.length - 1) {
            return message;
          }
        }
      });
    }
    return message;
  }

  private validateOffer(validationItem, recipe: ChildRecipeEntity): boolean {
    const validationDefaultValue = true;
    if (validationItem.rules) {
        let initialized = false;
        let valid = validationDefaultValue;
        validationItem.rules.forEach(rule => {
            const validationResult = this.validateRule(rule, recipe);
            if (initialized) {
                valid = validationResult;
                initialized = true;
            } else  {
              switch (validationItem.operator) {
                case 1:
                    valid = valid && validationResult;
                    break;
                case 0:
                    valid = valid || validationResult;
                    break;
              }
            }
        });
        return valid;
    }  else  {
        return validationDefaultValue;
    }
  }
  public isMenuOrCategoryInCheckoutFlow(router: Router, context: string) {
    const path = context === 'menu' ? '/offer' : context === 'menu_category' ? '/offer/' : null;
    if (!path) {
      return false;
    }
    if (router.url.indexOf(path) !== -1 ) {
      return true;
    }
  }
  private validateRule(rule, recipe: ChildRecipeEntity) {
    let count = 0;
    if (rule.customizationGroups)  {
      rule.customizationGroups.forEach (customizationGroup => {
        if (customizationGroup.modifierGroups) {
          customizationGroup.modifierGroups.forEach(modifierGroup => {
            if (modifierGroup.modifiers) {
              modifierGroup.modifiers.forEach(modifier => {
                if (this.matchesModifier(customizationGroup.customizationGroupId,
                    modifierGroup.modifierGroupId, modifier.modifierId, recipe)) {
                    count += 1;
                }
              });
            }
          });
        }
      });
    }
    return this.validCount(rule, count);
  }

  // Validate the offer min and max count
  private validCount(rule, count)  {
    let valid = true;
    if (rule.minCount) {
        valid = valid && (count >= rule.minCount);
    }
    if (rule.maxCount) {
        valid = valid && (count <= rule.maxCount);
    }
    return valid;
  }

  // Offers find customization groups match with child receipe customization groups.
  private matchesModifier(customizationGroupId, modifierGroupId, modifierId, recipe: ChildRecipeEntity) {
    const customizationGroup = recipe.customizationGroups.find(cg => cg.id === customizationGroupId);
    return this.customizationGroupsMatches(customizationGroup, customizationGroupId, modifierGroupId, modifierId);
  }

  // Offers find modifier group match with child receipe modifier group.
  private customizationGroupsMatches(customizationGroup, customizationGroupId, modifierGroupId, modifierId) {
    if (customizationGroup && customizationGroup.id === customizationGroupId) {
      if (customizationGroup.modifierGroups)  {
          const modifierGroup = customizationGroup.modifierGroups.find(mg => mg.id === modifierGroupId && mg.isSelected);
          if (modifierGroup) {
            return this.modifierGroupsMatches(modifierGroup, modifierGroupId, modifierId);
          }
      }
    }
    return false;
  }

  // Offers find modifiers id match with child receipe modifier id and isSelected.
  private modifierGroupsMatches(modifierGroup, modifierGroupId, modifierId) {
    if (modifierGroup && modifierGroup.id === modifierGroupId) {
        if (modifierGroup.modifiers) {
            return modifierGroup.modifiers.some(m => m.id === modifierId && (m.isSelected));
        } else { return true; }
    } else { return false; }
  }

  handleDuplicateOffer() {
    if (this.isOfferInCart) {
        this.confirmModalService.show(
          '',
          'Only one offer can be redeemed per order',
          '',
          'OK, Got It',
          '',
          '',
          true
        );
    }
    return this.isOfferInCart;
  }
}
